import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { SidebarMenu } from "vue-sidebar-menu";
import { storeToRefs } from "pinia";
import { onMounted } from "vue";
import { useU3tNavigationStore } from "@/stores/u3tNavigation";


export default /*@__PURE__*/_defineComponent({
  __name: 'SideBar',
  setup(__props) {

const useStore = useU3tNavigationStore();
const { navigation } = storeToRefs(useStore);

onMounted(async () => {
  await useStore.getNavigation();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(SidebarMenu), {
    menu: _unref(navigation),
    collapsed: true,
    width: "420px",
    widthCollapsed: "50px"
  }, null, 8, ["menu"]))
}
}

})